export const environment = {
  production: true,
  connection: {
    name: 'LH Hopfgarten Softline',
    host: 'https://softline.lagerhaus-hopfgarten.at/',
    port: 443,
    basePath: '/api'
  },
  androidUpdateRepository: ''
};
